import { createUser as x, generateUserKey as y, sendPerfMetrics as k, removeMessageFeedback as F, addMessageFeedback as T, getEvent as R, createEvent as w, deleteUser as I, updateUser as K, getUser as O, createFile as S, deleteMessage as _, getMessage as q, updateMessage as N, createMessage as z, listParticipants as A, getParticipant as J, removeParticipant as j, addParticipant as D, listConversationMessages as L, listConversations as V, deleteConversation as X, getConversation as Y, createConversation as B } from "./webchat-client3.js";
import { client as l } from "./webchat-client4.js";
import { EventSource as G } from "./webchat-client5.js";
import { throwErrorInterceptor as b } from "./webchat-client6.js";
import { createEventEmitter as C } from "./webchat-client7.js";
const n = (a) => a.data, $ = 10, M = 3e3, H = "60000", v = {
  throwOnError: !0
}, se = async ({
  clientId: a,
  apiUrl: c,
  adminSecret: i,
  customHeaders: o,
  ...s
}) => {
  const d = `${c || l.getConfig().baseUrl}/${a}`;
  l.interceptors.response._fns.length === 0 && l.interceptors.response.use(b);
  const t = {
    ...v,
    baseUrl: d
  }, h = {
    ...i ? { "x-admin-secret": i } : {},
    ...o
  };
  return x({
    ...t,
    headers: Object.keys(h).length > 0 ? h : void 0,
    body: s
  }).then(n);
}, ne = ({
  conversationId: a,
  userToken: c,
  clientId: i,
  apiUrl: o,
  adminSecret: s
}) => {
  let d = 0, t = null;
  const h = C(), e = () => {
    t && t.close();
    const g = `${`${o || l.getConfig().baseUrl}/${i}`}/initialize${a ? `?conversationId=${a}` : ""}`, p = {
      ...s ? { "x-admin-secret": s } : {},
      ...c ? { "x-user-key": c } : {}
    };
    t = P(g, p), t.onopen = () => h.emit("open"), t.onerror = (u) => {
      d < $ ? (d++, setTimeout(() => e(), M)) : h.emit("error", u);
    }, t.onmessage = (u) => {
      const m = E(u.data);
      h.emit(m.type, m.data);
    };
  };
  return e(), h.on;
}, re = async ({
  adminSecret: a,
  expiresAt: c,
  userId: i,
  apiUrl: o,
  clientId: s
}) => {
  const d = { "x-admin-secret": a }, t = `${o || l.getConfig().baseUrl}/${s}`, h = {
    ...v,
    baseUrl: t
  };
  return y({ ...h, headers: d, body: { id: i, expiresAt: c } }).then(n);
}, ae = async (a, c, i, o) => {
  const s = `${i || l.getConfig().baseUrl}/${a}`, d = {
    ...v,
    baseUrl: s
  };
  return k({ ...d, body: c, headers: o }).then(n);
}, oe = ({
  userKey: a,
  clientId: c,
  apiUrl: i,
  customHeaders: o
}) => {
  const s = {
    "x-user-key": a,
    ...o
  }, d = `${i || l.getConfig().baseUrl}/${c}`, t = {
    ...v,
    baseUrl: d
  };
  return l.interceptors.response._fns.length === 0 && l.interceptors.response.use(b), {
    createConversation: () => B({ ...t, headers: s, body: {} }).then(n),
    getConversation: ({ conversationId: e }) => Y({ ...t, headers: s, path: { id: e } }).then(n),
    deleteConversation: ({ conversationId: e }) => X({ ...t, headers: s, path: { id: e } }).then(n),
    listConversations: ({ nextToken: e }) => V({ ...t, headers: s, query: { nextToken: e } }).then(n),
    listConversationMessages: ({ conversationId: e, nextToken: r }) => L({
      ...t,
      headers: s,
      path: { id: e },
      query: { nextToken: r }
    }).then(n),
    addParticipant: ({ conversationId: e, userId: r }) => D({ ...t, headers: s, path: { id: e }, body: { userId: r } }).then(n),
    removeParticipant: ({ conversationId: e, userId: r }) => j({ ...t, headers: s, path: { id: e, userId: r } }).then(n),
    getParticipant: ({ conversationId: e, userId: r }) => J({ ...t, headers: s, path: { id: e, userId: r } }).then(n),
    listParticipants: ({ conversationId: e, nextToken: r }) => A({ ...t, headers: s, path: { id: e }, query: { nextToken: r } }).then(n),
    createMessage: (e) => z({ ...t, headers: s, body: e }).then(n),
    updateMessage: ({ messageId: e, ...r }) => N({ ...t, headers: s, path: { id: e }, body: r }).then(n),
    getMessage: ({ messageId: e }) => q({ ...t, headers: s, path: { id: e } }).then(n),
    deleteMessage: ({ messageId: e }) => _({ ...t, headers: s, path: { id: e } }).then(n),
    createFile: (e) => S({ ...t, headers: s, body: e }).then(n),
    getUser: () => O({ ...t, headers: s }).then(n),
    updateUser: (e) => K({ ...t, headers: s, body: e }).then(n),
    deleteUser: () => I({ ...t, headers: s }).then(n),
    createEvent: (e) => w({ ...t, headers: s, body: e }).then(n),
    getEvent: ({ eventId: e }) => R({ ...t, headers: s, path: { id: e } }).then(n),
    addMessageFeedback: ({ messageId: e, ...r }) => T({ ...t, headers: s, path: { id: e }, body: r }).then(n),
    removeMessageFeedback: ({ messageId: e }) => F({ ...t, headers: s, path: { id: e } }).then(n),
    generateUserKey: ({ adminSecret: e, ...r }) => y({ ...t, headers: { "x-admin-secret": e }, body: r }).then(n),
    listenConversation: ({ conversationId: e }) => {
      let r = 0, g = null;
      const p = C(), u = () => {
        g && g.close();
        const m = `${d}/conversations/${e}/listen`;
        g = P(m, s), g.onopen = () => p.emit("open"), g.onerror = (f) => {
          r < $ ? (r++, setTimeout(() => u(), M)) : p.emit("error", f);
        }, g.onmessage = (f) => {
          const U = E(f.data);
          p.emit(U.type, U.data);
        };
      };
      return u(), p.on;
    }
  };
}, E = (a) => {
  try {
    return JSON.parse(a);
  } catch {
    return a;
  }
}, P = (a, c) => new G(a, {
  fetch: (i, o) => fetch(i, {
    ...o,
    headers: {
      ...o == null ? void 0 : o.headers,
      ...c,
      timeout: H
    }
  })
});
export {
  oe as createClient,
  se as createUser,
  re as generateUserKey,
  ne as initialize,
  ae as sendPerfMetrics
};
